import type { Question } from '@mentimeter/http-clients';
import type { MultipleChoiceStaticContent } from '@core-api/editor/types/response';
import { CORRECT_ANSWER_MODE_ENABLED } from '../../../constants';

export const correctAnswerModeToQuestionShowCorrect = (
  correctAnswerMode: MultipleChoiceStaticContent['interactiveContentStyling']['correctAnswerMode'],
): Question['show_correct'] => {
  return correctAnswerMode === CORRECT_ANSWER_MODE_ENABLED;
};
